import { Pipe, PipeTransform } from '@angular/core';
import { EligibiliteBeneficiaire } from '../../models/eligibiliteBeneficiaire';

@Pipe({
	name: 'filterEligibiliteBeneficiaireByName'
})
export class FilterEligibiliteBeneficiaireByNamePipe implements PipeTransform {
	transform(eligibiliteBeneficiaire: EligibiliteBeneficiaire[], filter: string): EligibiliteBeneficiaire[] {
		if (
			!eligibiliteBeneficiaire ||
			!filter ||
			eligibiliteBeneficiaire === null ||
			filter === null ||
			filter === ''
		) {
			return eligibiliteBeneficiaire;
		}

		return eligibiliteBeneficiaire.filter((eligibiliteBeneficiaire: EligibiliteBeneficiaire) => {
			if (eligibiliteBeneficiaire.name) {
				// TODO: add lastName too
				return eligibiliteBeneficiaire.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
